import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import WorshipServices from "./pages/WorshipServices";
import MinistriesPrograms from "./pages/MinistriesPrograms";
import Events from "./pages/Events";
import GetInvolved from "./pages/GetInvolved";
import ContactUs from "./pages/ContactUs";
import SermonsMedia from "./pages/SermonsMedia";
import FAQs from "./pages/FAQs";
import { Box } from "@mui/material";



const App = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "background.default",
        color: "text.primary",
      }}
    >
      {/* Navbar at the top */}
      <Navbar />

      {/* Main content area */}
      <Box sx={{ flex: 1, py: 3 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/worship-services" element={<WorshipServices />} />
          <Route path="/ministries-programs" element={<MinistriesPrograms />} />
          <Route path="/events" element={<Events />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/sermons-media" element={<SermonsMedia />} />
          <Route path="/faqs" element={<FAQs />} />
        </Routes>
      </Box>

      {/* Footer at the bottom */}
      <Footer />
    </Box>
  );
};

export default App;
